import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const OnboardingModal = ({ show, handleClose }) => {
  const [step, setStep] = useState(0);
  const steps = [
    {
      title: "Welcome to FLUX.1",
      content: "Meet FLUX.1 [dev] from Black Forest Labs — a groundbreaking AI model changing the game in image generation.",
      image: "https://rszr.getimg.ai/resize?url=https%3A%2F%2Fgetimg.ai%2Fonboarding%2Fgetimg-flux.jpg&type=auto&width=1200&speed=5",
    },
    {
      title: "Exceptional Quality",
      content: "It offers exceptional image quality even with simple prompts, handles complex compositions with ease.",
      image: "path/to/image2.jpg",
    },
    {
      title: "Rendering Text",
      content: "Excels at rendering text within images. Try it now in Essential mode.",
      image: "path/to/image3.jpg",
    },
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      handleClose();
    }
  };

  const handleDontShowAgain = () => {
    localStorage.setItem('hideOnboarding', 'true');
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{steps[step].title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={steps[step].image} alt={steps[step].title} style={{ width: '100%', marginBottom: '15px' }} />
        <p>{steps[step].content}</p>
        
        <div className='d-flex justify-content-end'>
        <Button variant="outline-secondary" onClick={handleClose} className='me-1'>
          Close
        </Button>
        <Button variant="outline-dark" onClick={handleNext}>
          {step < steps.length - 1 ? 'Continue' : 'Finish'}
        </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className='font-small'>
        <Form.Check
          type="checkbox"
          label="Don't show me this again."
          onChange={handleDontShowAgain}
        />
        
      </Modal.Footer>
    </Modal>
  );
};

export default OnboardingModal;